export default __webpack_public_path__ + "static/media/searchLW.c2d486ab.svg";